/**
 * Utility functions for bulk actions on transaction data
 */

/**
 * Add a tag to all filtered rows
 */
export const bulkAddTag = (tableData, filteredIds, value) => {
  return tableData.map(row => {
    if (filteredIds.has(row.id) && !row.tags.includes(value)) {
      return {
        ...row,
        tags: [...row.tags, value].sort()
      };
    }
    return row;
  });
};

/**
 * Remove a tag from all filtered rows
 */
export const bulkRemoveTag = (tableData, filteredIds, value) => {
  return tableData.map(row => {
    if (filteredIds.has(row.id)) {
      return {
        ...row,
        tags: row.tags.filter(tag => tag !== value)
      };
    }
    return row;
  });
};

/**
 * Set tax checkbox to true for all filtered rows
 */
export const bulkTickTax = (tableData, filteredIds) => {
  return tableData.map(row => {
    if (filteredIds.has(row.id)) {
      return {
        ...row,
        tax: true
      };
    }
    return row;
  });
};

/**
 * Set tax checkbox to false for all filtered rows
 */
export const bulkUntickTax = (tableData, filteredIds) => {
  return tableData.map(row => {
    if (filteredIds.has(row.id)) {
      return {
        ...row,
        tax: false
      };
    }
    return row;
  });
};

/**
 * Set comment for all filtered rows
 */
export const bulkSetComment = (tableData, filteredIds, value) => {
  return tableData.map(row => {
    if (filteredIds.has(row.id)) {
      return {
        ...row,
        comments: value
      };
    }
    return row;
  });
};

/**
 * Clear comments for all filtered rows
 */
export const bulkClearComment = (tableData, filteredIds) => {
  return tableData.map(row => {
    if (filteredIds.has(row.id)) {
      return {
        ...row,
        comments: ''
      };
    }
    return row;
  });
};